import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svg/MetaMaskIcon.svg'
import _imports_1 from '../../assets/sepoliaIcon.svg'
import _imports_2 from '../../assets/BSCIcon.png'
import _imports_3 from '../../assets/PolygonIcon.png'
import _imports_4 from '../../assets/USDC-icon.png'
import _imports_5 from '../../assets/USDT-icon.png'


const _withScopeId = n => (_pushScopeId("data-v-74a0c607"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "confirm_container" }
const _hoisted_2 = { class: "confirm_container__header" }
const _hoisted_3 = { class: "confirm_container__body" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_7 = { style: {"text-align":"center","margin":"20px"} }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"height":"30px"},
  src: _imports_0
}, null, -1 /* HOISTED */))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "or", -1 /* HOISTED */))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_12 = {
  key: 0,
  class: "box-shadow",
  style: {"padding":"20px","color":"black"}
}
const _hoisted_13 = { style: {"width":"100%"} }
const _hoisted_14 = { style: {"padding":"10px 30px"} }
const _hoisted_15 = { class: "col-12" }
const _hoisted_16 = {
  key: 0,
  class: "flex align-items-center"
}
const _hoisted_17 = { class: "flag" }
const _hoisted_18 = {
  key: 0,
  src: _imports_1,
  alt: "stablecoin symbol",
  class: "h-full"
}
const _hoisted_19 = {
  key: 1,
  src: _imports_2,
  alt: "stablecoin symbol",
  class: "h-full"
}
const _hoisted_20 = {
  key: 2,
  src: _imports_3,
  alt: "stablecoin symbol",
  class: "h-full"
}
const _hoisted_21 = { class: "flex align-items-center" }
const _hoisted_22 = { class: "flag" }
const _hoisted_23 = {
  key: 0,
  src: _imports_1,
  alt: "stablecoin symbol",
  class: "h-full"
}
const _hoisted_24 = {
  key: 1,
  src: _imports_2,
  alt: "stablecoin symbol",
  class: "h-full"
}
const _hoisted_25 = {
  key: 2,
  src: _imports_3,
  alt: "stablecoin symbol",
  class: "h-full"
}
const _hoisted_26 = { class: "invalid-feedback" }
const _hoisted_27 = { class: "col-12" }
const _hoisted_28 = {
  key: 0,
  class: "flex align-items-center"
}
const _hoisted_29 = { class: "flag" }
const _hoisted_30 = {
  key: 0,
  src: _imports_4,
  alt: "stablecoin symbol",
  class: "h-full"
}
const _hoisted_31 = {
  key: 1,
  src: _imports_5,
  alt: "stablecoin symbol",
  class: "h-full"
}
const _hoisted_32 = { class: "flex align-items-center" }
const _hoisted_33 = { class: "flag" }
const _hoisted_34 = {
  key: 0,
  src: _imports_4,
  alt: "stablecoin symbol",
  class: "h-full"
}
const _hoisted_35 = {
  key: 1,
  src: _imports_5,
  alt: "stablecoin symbol",
  class: "h-full"
}
const _hoisted_36 = { class: "invalid-feedback" }
const _hoisted_37 = { class: "field col-12" }
const _hoisted_38 = { class: "invalid-feedback" }
const _hoisted_39 = {
  key: 0,
  style: {"display":"flex"}
}
const _hoisted_40 = { style: {"margin-right":"20px"} }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "The payment must be done from metamask address (source address)", -1 /* HOISTED */))
const _hoisted_42 = { class: "address" }
const _hoisted_43 = {
  class: "address",
  style: {"margin-bottom":"20px"}
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_45 = { style: {"margin-left":"auto","margin-right":"20px"} }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"10px"} }, "Recipient's address", -1 /* HOISTED */))
const _hoisted_47 = { class: "flex justify-content-center" }
const _hoisted_48 = { style: {"display":"flex","align-items":"center","justify-content":"center","flex-direction":"column","color":"black","font-weight":"600"} }
const _hoisted_49 = { class: "requirements_container" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Amount", -1 /* HOISTED */))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1 /* HOISTED */))
const _hoisted_52 = {
  key: 0,
  style: {"font-size":"0.7em"},
  class: "warning"
}
const _hoisted_53 = {
  key: 1,
  style: {"font-size":"0.7em"},
  class: "warning"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Destination address", -1 /* HOISTED */))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Blockchain", -1 /* HOISTED */))
const _hoisted_56 = { style: {"display":"flex"} }
const _hoisted_57 = {
  key: 0,
  class: "flex align-items-center"
}
const _hoisted_58 = { class: "flag" }
const _hoisted_59 = {
  key: 0,
  src: _imports_1,
  alt: "stablecoin symbol",
  class: "h-full"
}
const _hoisted_60 = {
  key: 1,
  src: _imports_2,
  alt: "stablecoin symbol",
  class: "h-full"
}
const _hoisted_61 = {
  key: 2,
  src: _imports_3,
  alt: "stablecoin symbol",
  class: "h-full"
}
const _hoisted_62 = { class: "flex align-items-center" }
const _hoisted_63 = { class: "flag" }
const _hoisted_64 = {
  key: 0,
  src: _imports_1,
  alt: "stablecoin symbol",
  class: "h-full"
}
const _hoisted_65 = {
  key: 1,
  src: _imports_2,
  alt: "stablecoin symbol",
  class: "h-full"
}
const _hoisted_66 = {
  key: 2,
  src: _imports_3,
  alt: "stablecoin symbol",
  class: "h-full"
}
const _hoisted_67 = {
  key: 0,
  class: "warning",
  style: {"margin":"auto 15px"}
}
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Token", -1 /* HOISTED */))
const _hoisted_69 = { style: {"display":"flex"} }
const _hoisted_70 = {
  key: 0,
  class: "flex align-items-center"
}
const _hoisted_71 = { class: "flag" }
const _hoisted_72 = {
  key: 0,
  src: _imports_4,
  alt: "stablecoin symbol",
  class: "h-full"
}
const _hoisted_73 = {
  key: 1,
  src: _imports_5,
  alt: "stablecoin symbol",
  class: "h-full"
}
const _hoisted_74 = { class: "flex align-items-center" }
const _hoisted_75 = { class: "flag" }
const _hoisted_76 = {
  key: 0,
  src: _imports_4,
  alt: "stablecoin symbol",
  class: "h-full"
}
const _hoisted_77 = {
  key: 1,
  src: _imports_5,
  alt: "stablecoin symbol",
  class: "h-full"
}
const _hoisted_78 = {
  key: 0,
  class: "warning",
  style: {"margin":"auto 15px"}
}
const _hoisted_79 = { class: "flex justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('PAYMENT_CONFIRMATION_VIEW.CONFIRM_PAYMENT')), 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('PAYMENT_CONFIRMATION_VIEW.SUMMARY.FIRST_LINE', {orderId: $setup.transactionContextStore.orderId})) + ".", 1 /* TEXT */),
      _hoisted_4,
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('PAYMENT_CONFIRMATION_VIEW.SUMMARY.SECOND_LINE')), 1 /* TEXT */),
      _createTextVNode(),
      _hoisted_5,
      _createElementVNode("span", null, [
        _createTextVNode(_toDisplayString(_ctx.$t('PAYMENT_CONFIRMATION_VIEW.SUMMARY.THIRD_LINE_1')) + " ", 1 /* TEXT */),
        _createElementVNode("b", null, _toDisplayString($setup.transactionContextStore.amountToPay.amount.toString()) + " " + _toDisplayString($setup.transactionContextStore.paymentCurrency), 1 /* TEXT */),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('PAYMENT_CONFIRMATION_VIEW.SUMMARY.THIRD_LINE_2')), 1 /* TEXT */)
      ]),
      _createTextVNode(),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_Button, {
          class: "secondary",
          style: {"width":"40%","min-width":"300px"},
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.paymentModalVisible = true))
        }, {
          default: _withCtx(() => [
            _hoisted_8,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('PAYMENT_CONFIRMATION_VIEW.SUMMARY.PAY')) + " " + _toDisplayString($setup.transactionContextStore.amountToPay.amount.toString()) + " " + _toDisplayString($setup.transactionContextStore.paymentCurrency) + " " + _toDisplayString(_ctx.$t('PAYMENT_CONFIRMATION_VIEW.SUMMARY.THIRD_LINE_2')), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }),
        _createTextVNode(),
        _hoisted_9,
        _hoisted_10,
        _hoisted_11,
        _createElementVNode("span", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.showManualPayment == true ? $setup.showManualPayment = false : $setup.warningModalVisibility = true)),
          class: "underline open"
        }, "Provide TxHash manually")
      ]),
      ($setup.showManualPayment)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createTextVNode(" After completing the transaction, please enter the txHash below "),
              _createElementVNode("span", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.showManualPayment = false)),
                class: "close"
              }, [
                _createTextVNode("Hide "),
                _createVNode($setup["IconComponent"], { name: "X" })
              ])
            ]),
            _createElementVNode("div", null, [
              _createVNode($setup["Form"], {
                onSubmit: $setup.onConfirmPayment,
                "validation-schema": $setup.schema
              }, {
                default: _withCtx(({errors}) => [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode($setup["Field"], {
                          modelValue: $setup.selectedBlockchain,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.selectedBlockchain) = $event)),
                          required: "",
                          name: "selectedBlockchain"
                        }, {
                          default: _withCtx(() => [
                            _createCommentVNode("                    <option v-for=\"network in blockchainNetworkList\" :key=\"network.id\" :value=\"network\">{{network.chainName}}</option>"),
                            _createVNode($setup["Dropdown"], {
                              modelValue: $setup.selectedBlockchain,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.selectedBlockchain) = $event)),
                              options: $setup.blockchainNetworkList,
                              placeholder: "Select blockchain",
                              style: {"height":"52px"},
                              class: _normalizeClass(["form-control dropdown flex align-items-center", {'is-invalid': errors.selectedBlockchain}])
                            }, {
                              value: _withCtx((slotProps) => [
                                (slotProps.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                      _createElementVNode("div", _hoisted_17, [
                                        (slotProps.value.chainName == $setup.CHAIN_NAME.SEPOLIA)
                                          ? (_openBlock(), _createElementBlock("img", _hoisted_18))
                                          : _createCommentVNode("v-if", true),
                                        (slotProps.value.chainName == $setup.CHAIN_NAME.BSC)
                                          ? (_openBlock(), _createElementBlock("img", _hoisted_19))
                                          : _createCommentVNode("v-if", true),
                                        (slotProps.value.chainName == $setup.CHAIN_NAME.POLYGON)
                                          ? (_openBlock(), _createElementBlock("img", _hoisted_20))
                                          : _createCommentVNode("v-if", true)
                                      ]),
                                      _createElementVNode("div", null, _toDisplayString(slotProps.value.chainName), 1 /* TEXT */)
                                    ]))
                                  : _createCommentVNode("v-if", true)
                              ]),
                              option: _withCtx((slotProps) => [
                                _createElementVNode("div", _hoisted_21, [
                                  _createElementVNode("div", _hoisted_22, [
                                    (slotProps.option.chainName == $setup.CHAIN_NAME.SEPOLIA)
                                      ? (_openBlock(), _createElementBlock("img", _hoisted_23))
                                      : _createCommentVNode("v-if", true),
                                    (slotProps.option.chainName == $setup.CHAIN_NAME.BSC)
                                      ? (_openBlock(), _createElementBlock("img", _hoisted_24))
                                      : _createCommentVNode("v-if", true),
                                    (slotProps.option.chainName == $setup.CHAIN_NAME.POLYGON)
                                      ? (_openBlock(), _createElementBlock("img", _hoisted_25))
                                      : _createCommentVNode("v-if", true)
                                  ]),
                                  _createElementVNode("div", null, _toDisplayString(slotProps.option.chainName), 1 /* TEXT */)
                                ])
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "options", "class"])
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue"]),
                        _createElementVNode("div", _hoisted_26, _toDisplayString(errors.selectedBlockchain ? _ctx.$t(errors.selectedBlockchain) : ''), 1 /* TEXT */)
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _createVNode($setup["Field"], {
                          modelValue: $setup.selectedToken,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.selectedToken) = $event)),
                          required: "",
                          name: "selectedToken"
                        }, {
                          default: _withCtx(() => [
                            _createVNode($setup["Dropdown"], {
                              modelValue: $setup.selectedToken,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.selectedToken) = $event)),
                              options: $setup.selectedBlockchainTokens==undefined ? [] : $setup.selectedBlockchainTokens,
                              placeholder: "Select token",
                              style: {"height":"52px"},
                              class: _normalizeClass(["form-control dropdown flex align-items-center", {'is-invalid': errors.selectedToken}])
                            }, {
                              value: _withCtx((slotProps) => [
                                (slotProps.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                      _createElementVNode("div", _hoisted_29, [
                                        (slotProps.value.name == $setup.TOKEN_NAME.USDC)
                                          ? (_openBlock(), _createElementBlock("img", _hoisted_30))
                                          : _createCommentVNode("v-if", true),
                                        (slotProps.value.name == $setup.TOKEN_NAME.USDT)
                                          ? (_openBlock(), _createElementBlock("img", _hoisted_31))
                                          : _createCommentVNode("v-if", true)
                                      ]),
                                      _createElementVNode("div", null, _toDisplayString(slotProps.value.name), 1 /* TEXT */)
                                    ]))
                                  : _createCommentVNode("v-if", true)
                              ]),
                              option: _withCtx((slotProps) => [
                                _createElementVNode("div", _hoisted_32, [
                                  _createElementVNode("div", _hoisted_33, [
                                    (slotProps.option.name == $setup.TOKEN_NAME.USDC)
                                      ? (_openBlock(), _createElementBlock("img", _hoisted_34))
                                      : _createCommentVNode("v-if", true),
                                    (slotProps.option.name == $setup.TOKEN_NAME.USDT)
                                      ? (_openBlock(), _createElementBlock("img", _hoisted_35))
                                      : _createCommentVNode("v-if", true)
                                  ]),
                                  _createElementVNode("div", null, _toDisplayString(slotProps.option.name), 1 /* TEXT */)
                                ])
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "options", "class"])
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue"]),
                        _createElementVNode("div", _hoisted_36, _toDisplayString(errors.selectedToken ? _ctx.$t(errors.selectedToken) : ''), 1 /* TEXT */)
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        _createVNode($setup["Field"], {
                          style: {"width":"100%"},
                          modelValue: $setup.txHash,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.txHash) = $event)),
                          placeholder: "TxHash",
                          name: "txHash",
                          type: "text",
                          class: _normalizeClass(["form-control", {'is-invalid': errors.txHash}])
                        }, null, 8 /* PROPS */, ["modelValue", "class"]),
                        _createElementVNode("div", _hoisted_38, _toDisplayString(errors.txHash ? _ctx.$t(errors.txHash) : ''), 1 /* TEXT */)
                      ])
                    ])
                  ]),
                  ($setup.selectedToken?.recipientAddress)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                        _createElementVNode("div", _hoisted_40, [
                          _hoisted_41,
                          _createElementVNode("div", _hoisted_42, _toDisplayString($setup.sourceAddress), 1 /* TEXT */),
                          _createElementVNode("span", null, [
                            _createTextVNode("Please send "),
                            _createElementVNode("b", null, _toDisplayString($setup.transactionContextStore.amountToPay.amount.toString()) + " " + _toDisplayString($setup.transactionContextStore.paymentCurrency), 1 /* TEXT */),
                            _createTextVNode(" to the address below:")
                          ]),
                          _createElementVNode("div", _hoisted_43, [
                            _createTextVNode(_toDisplayString($setup.selectedToken?.recipientAddress) + " ", 1 /* TEXT */),
                            _createVNode($setup["Icon"], {
                              class: "address__copy",
                              name: "Copy",
                              onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.copyRecipientAddress()))
                            }),
                            _createTextVNode(),
                            _hoisted_44
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_45, [
                          _hoisted_46,
                          _createVNode($setup["QrcodeVue"], {
                            value: $setup.selectedToken?.recipientAddress,
                            size: "200",
                            "render-as": 'svg'
                          }, null, 8 /* PROPS */, ["value"])
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("div", _hoisted_47, [
                    _createVNode(_component_Button, {
                      class: "p-button p-component secondary",
                      type: "submit"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("CONFIRM PAYMENT")
                      ]),
                      _: 1 /* STABLE */
                    })
                  ])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["validation-schema"])
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _createVNode($setup["Dialog"], {
      visible: $setup.paymentModalVisible,
      "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => (($setup.paymentModalVisible) = $event)),
      modal: "",
      header: "MetaMask Payment",
      baseZIndex: -100,
      style: { width: '95vw', 'max-width': '700px'}
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, [
            _hoisted_50,
            _createElementVNode("div", null, _toDisplayString($setup.transactionContextStore.amountToPay.amount.toString()) + " " + _toDisplayString($setup.transactionContextStore.paymentCurrency), 1 /* TEXT */),
            _createElementVNode("div", {
              class: _normalizeClass({'warning': $setup.addressNotMatch})
            }, "Source address", 2 /* CLASS */),
            _withDirectives((_openBlock(), _createElementBlock("div", {
              class: _normalizeClass({'warning': $setup.addressNotMatch})
            }, [
              _createTextVNode(_toDisplayString($setup.currentMetamaskAddress), 1 /* TEXT */)
            ], 2 /* CLASS */)), [
              [_directive_tooltip, { value: $setup.sourceAddress, escape: true }]
            ]),
            _hoisted_51,
            ($setup.addressNotMatch)
              ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                  _createVNode($setup["Icon"], { name: "AlertCircle" }),
                  _createTextVNode(" Wrong address. Change to " + _toDisplayString($setup.sourceAddress), 1 /* TEXT */)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_53, [
                  _createVNode($setup["Icon"], { name: "AlertCircle" }),
                  _createTextVNode(" Please make sure that your metamask account is the same as source address ")
                ])),
            _hoisted_54,
            _withDirectives((_openBlock(), _createElementBlock("div", null, [
              _createTextVNode(_toDisplayString($setup.selectedToken?.recipientAddress), 1 /* TEXT */)
            ])), [
              [_directive_tooltip, { value: $setup.selectedToken?.recipientAddress ? $setup.selectedToken.recipientAddress : '', escape: true }]
            ]),
            _hoisted_55,
            _createElementVNode("div", _hoisted_56, [
              _createVNode($setup["Dropdown"], {
                onChange: $setup.onNetworkChange,
                modelValue: $setup.selectedBlockchain,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.selectedBlockchain) = $event)),
                options: $setup.blockchainNetworkList,
                placeholder: "Select blockchain",
                style: {"max-width":"180px","height":"52px"},
                class: "dropdown flex align-items-center"
              }, {
                value: _withCtx((slotProps) => [
                  (slotProps.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                        _createElementVNode("div", _hoisted_58, [
                          (slotProps.value.chainName == $setup.CHAIN_NAME.SEPOLIA)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_59))
                            : _createCommentVNode("v-if", true),
                          (slotProps.value.chainName == $setup.CHAIN_NAME.BSC)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_60))
                            : _createCommentVNode("v-if", true),
                          (slotProps.value.chainName == $setup.CHAIN_NAME.POLYGON)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_61))
                            : _createCommentVNode("v-if", true)
                        ]),
                        _createElementVNode("div", null, _toDisplayString(slotProps.value.chainName), 1 /* TEXT */)
                      ]))
                    : _createCommentVNode("v-if", true)
                ]),
                option: _withCtx((slotProps) => [
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("div", _hoisted_63, [
                      (slotProps.option.chainName == $setup.CHAIN_NAME.SEPOLIA)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_64))
                        : _createCommentVNode("v-if", true),
                      (slotProps.option.chainName == $setup.CHAIN_NAME.BSC)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_65))
                        : _createCommentVNode("v-if", true),
                      (slotProps.option.chainName == $setup.CHAIN_NAME.POLYGON)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_66))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _createElementVNode("div", null, _toDisplayString(slotProps.option.chainName), 1 /* TEXT */)
                  ])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["modelValue", "options"]),
              (!$setup.selectedBlockchain)
                ? (_openBlock(), _createElementBlock("div", _hoisted_67, " Not selected "))
                : _createCommentVNode("v-if", true)
            ]),
            _hoisted_68,
            _createElementVNode("div", _hoisted_69, [
              _createVNode($setup["Dropdown"], {
                modelValue: $setup.selectedToken,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.selectedToken) = $event)),
                options: $setup.selectedBlockchainTokens==undefined ? [] : $setup.selectedBlockchainTokens,
                placeholder: "Select token",
                style: {"max-width":"180px","height":"52px"},
                class: "dropdown flex align-items-center"
              }, {
                value: _withCtx((slotProps) => [
                  (slotProps.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                        _createElementVNode("div", _hoisted_71, [
                          (slotProps.value.name == $setup.TOKEN_NAME.USDC)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_72))
                            : _createCommentVNode("v-if", true),
                          (slotProps.value.name == $setup.TOKEN_NAME.USDT)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_73))
                            : _createCommentVNode("v-if", true)
                        ]),
                        _createElementVNode("div", null, _toDisplayString(slotProps.value.name), 1 /* TEXT */)
                      ]))
                    : _createCommentVNode("v-if", true)
                ]),
                option: _withCtx((slotProps) => [
                  _createElementVNode("div", _hoisted_74, [
                    _createElementVNode("div", _hoisted_75, [
                      (slotProps.option.name == $setup.TOKEN_NAME.USDC)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_76))
                        : _createCommentVNode("v-if", true),
                      (slotProps.option.name == $setup.TOKEN_NAME.USDT)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_77))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _createElementVNode("div", null, _toDisplayString(slotProps.option.name), 1 /* TEXT */)
                  ])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["modelValue", "options"]),
              (!$setup.selectedToken)
                ? (_openBlock(), _createElementBlock("div", _hoisted_78, " Not selected "))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_79, [
            _createVNode(_component_Button, {
              class: "p-button p-component secondary",
              onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.paymentModalVisible=false))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Close")
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_Button, {
              class: "p-button p-component secondary",
              style: {"white-space":"nowrap"},
              onClick: _cache[12] || (_cache[12] = ($event: any) => ($setup.onStartMetamaskTransaction())),
              disabled: $setup.addressNotMatch || !$setup.blockchainAndTokenSelected()
            }, {
              default: _withCtx(() => [
                _createTextVNode("Start MetaMask transaction")
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["disabled"])
          ]),
          _createCommentVNode("        <Form @submit=\"onStartMetamaskTransaction\" :validation-schema=\"modalSchema\" v-slot=\"{errors}\" >"),
          _createCommentVNode("          <div style=\"padding: 10px 30px;\">"),
          _createCommentVNode("            <div >"),
          _createCommentVNode("              <div class=\"field col-12\">"),
          _createCommentVNode("                <Field v-model=\"selectedBlockchainNetworkId\" required name=\"selectedBlockchainNetwork\" as=\"select\" class=\"form-control\""),
          _createCommentVNode("                       :class=\"{'is-invalid': errors.selectedBlockchainNetwork}\" @change=\"onNetworkChange\">"),
          _createCommentVNode("                  <option v-for=\"network in blockchainNetworkList\" :key=\"network\" :value=\"network.chainId\">{{network.chainName}}</option>"),
          _createCommentVNode("                </Field>"),
          _createCommentVNode("                <span>Network</span>"),
          _createCommentVNode("                <div class=\"invalid-feedback\">{{ errors.selectedBlockchainNetwork ? $t(errors.selectedBlockchainNetwork) : '' }}</div>"),
          _createCommentVNode("              </div>"),
          _createCommentVNode("              <div class=\"field col-12\">"),
          _createCommentVNode("                <Field v-model=\"selectedTokenIdentifier\" required name=\"selectedTokenIdentifier\" as=\"select\" class=\"form-control\""),
          _createCommentVNode("                       :class=\"{'is-invalid': errors.selectedTokenIdentifier}\">"),
          _createCommentVNode("                     <option v-for=\"token in selectedBlockchainTokens\" :key=\"token\" :value=\"token.coinIdentifier\">{{token.name}}</option>"),
          _createCommentVNode("                </Field>"),
          _createCommentVNode("                <span>Token</span>"),
          _createCommentVNode("                <div class=\"invalid-feedback\">{{ errors.selectedBlockchainNetwork ? $t(errors.selectedBlockchainNetwork) : '' }}</div>"),
          _createCommentVNode("              </div>"),
          _createCommentVNode("            </div>"),
          _createCommentVNode("          </div>"),
          _createCommentVNode("          <div class=\"flex justify-content-center\">"),
          _createCommentVNode("            <Button class=\"p-button p-component secondary\" @click=\"paymentModalVisible=false\">Close</Button>"),
          _createCommentVNode("            <Button class=\"p-button p-component secondary\" style=\"white-space: nowrap;\"  type=\"submit\" :disabled=\"addressNotMatch\" >Start MetaMask transaction</Button>"),
          _createCommentVNode("          </div>"),
          _createCommentVNode("        </Form>")
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["visible"]),
    _createVNode($setup["WarningModal"], {
      visible: $setup.warningModalVisibility,
      onConfirm: _cache[14] || (_cache[14] = ($event: any) => {$setup.showManualPayment = true; $setup.warningModalVisibility=false}),
      onCloseModal: _cache[15] || (_cache[15] = ($event: any) => ($setup.warningModalVisibility = false))
    }, null, 8 /* PROPS */, ["visible"])
  ]))
}